<template>
  <div class="wrapper">
    <div class="row">
      <div class="col-md">
        <div class="form-group">
          <label>Name:</label>
          <div class="input-group">
            <input class="form-control" v-model="table.table.name" type="text"/>
            <div class="input-group-append">
              <button class="btn btn-primary" @click="$emit('edit')"><font-awesome-icon icon="edit"/></button>
              <button class="btn btn-danger" @click="$emit('delete')"><font-awesome-icon icon="trash"/></button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Datenquelle:</label>
          <div class="input-group">
            <select @change="table.datasource.type = 'referer'" v-model="table.datasource.refid" class="form-control">
              <option v-for="s in sources" :key="s.name" :value="s.name">{{ s.name }}</option>
            </select>
            <div class="input-group-append">
              <button @click="editSource(table.datasource)" class="btn btn-secondary">...</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="form-group">
          <label>Angehängte Tabellen</label>
          <div class="input-group">
            <select v-model="joinidx" class="form-control">
              <option v-for="(j,idx) in table.table.joins" :key="idx" :value="idx">{{ j.table.name }}</option>
            </select>
            <div class="input-group-append">
              <div class="btn-group">
                <button @click="$emit('editjoin',{tidx: index, jidx: joinidx})" class="btn btn-primary"><font-awesome-icon icon="edit"/></button>
                <button @click="addJoin" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
                <button @click="deleteJoin" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="joinidx >= 0" class="form-group">
          <label>Datenquelle:</label>
          <div class="input-group">
            <select @change="table.table.joins[joinidx].datasource.type = 'referer'" v-model="table.table.joins[joinidx].datasource.refid" class="form-control">
              <option v-for="s in sources" :key="s.name" :value="s.name">{{ s.name }}</option>
            </select>
            <div class="input-group-append">
              <button @click.capture="editSource(table.table.joins[joinidx].datasource)" class="btn btn-secondary">...</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal :id="'sourceEditor' + index" size="lg" @shown="setEditSource" title="Datenquelle" ok-only @ok="updateEditSource">
      <DataSourceEditor ref="srceditor"/>
    </b-modal>
  </div>
</template>

<script>
import DataSourceEditor from '@/components/genericdata/DataSourceEditor.vue'

export default {
  name: 'DataTableItem',
  props: ["table","sources","index"],
  components: {
    DataSourceEditor,
  },
  data() {
    return {
      editData: {},
      joinidx: -1,
    }
  },
  methods: {
    addJoin: function() {
      if (!this.table.table.joins) this.table.table.joins = [];
      this.table.table.joins.push({table:{name: 'Join' + this.table.table.joins.length ,joins:[]},datasource:{}});
      this.joinidx = this.table.table.joins.length - 1;
    },
    deleteJoin: function() {
      console.log('delete');
      console.log(this.joinidx);
      if (confirm('Möchten Sie die angehängte Tabelle: ' + this.table.table.joins[this.joinidx].table.name + ' wirklich löschen?')) {
        this.table.table.joins.splice(this.joinidx,1);
        console.log(JSON.stringify(this.table.table.joins));
      }
    },
    setEditSource: function() {
      console.log('set source');
      // remove ref if not needed
      if (this.editData.type !== 'referer') {
        delete this.editData.refid;
      }
      console.log(JSON.stringify(this.editData));
      this.$refs.srceditor.setSource(this.editData);
    },
    updateEditSource() {
      console.log('update edit source');
      this.$refs.srceditor.getSource();
    },
    editSource: function(ds) {
      console.log('edit source ' + this);
      console.log(ds);
      this.editData = ds;
      this.$bvModal.show('sourceEditor' + this.index);
    }
  }
}
</script>
